export default __webpack_public_path__ + "locales/hy-AM/JavascriptSdk.json?hash=4f076f40751d6169a81d6e3765eff322";